export const CLASS_BOARD_ATTACHMENTS = 'board-attachments';
